import React from "react";
import SeoHead from "../../../components/SeoHead";
import AboutHero from "./AboutHero";
import OurStory from "./OurStory";
import MissionVision from "./MissionVision";
import CoreValues from "./CoreValues";
import OurImpact from "./OurImpact";
import Explore from "./Explore";

function About() {
  return (
    <div id="about">
      <SeoHead title="About Us" description="Learn about NdovuPay — our story, mission, values and the team behind Kenya's leading business payment management platform." path="/about" />
      <AboutHero />
      <OurStory />
      <MissionVision />
      <CoreValues />
      <OurImpact />
      <Explore />
    </div>
  );
}

export default About;
